import { CalendarClock, Loader2 } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import { expiredQuoteMessage } from '@/lib/quote/expiredMessage';
import { fmtDateOnly, useQuoteActions } from '../quoteActionContext';

// The itemized action rail. Approval opens the same modal as single-scope so the
// signature, payment consent, totals and terms never compete with a 340px rail.
// Decline intentionally keeps its existing compact inline form.
export function ApproveDeclineSlot() {
  const {
    showDeclineForm,
    setShowDeclineForm,
    setApproveModalOpen,
    expiredWhileActionable,
    approveAndPay,
    approveButtonClass,
    submitting,
    declineReason,
    setDeclineReason,
    handleDecline,
    estimate,
    v,
  } = useQuoteActions();

  return (
    <div className="mt-6 space-y-4 border-t pt-6">
      {showDeclineForm ? (
        <div className="space-y-2">
          <label htmlFor="decline-reason" className="block text-sm font-medium text-[#374151]">
            Reason for declining (optional)
          </label>
          <textarea
            id="decline-reason"
            className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-black focus:outline-none"
            rows={3}
            placeholder="Let us know why you're declining..."
            value={declineReason}
            onChange={(e) => setDeclineReason(e.target.value)}
            maxLength={2000}
          />
          <div className="flex gap-2">
            <Button
              variant="outline"
              className="flex-1"
              onClick={() => {
                setShowDeclineForm(false);
                setDeclineReason('');
              }}
              disabled={submitting}
            >
              Cancel
            </Button>
            <Button
              className="flex-1 bg-red-600 text-white hover:bg-red-700"
              onClick={handleDecline}
              disabled={submitting}
            >
              {submitting ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
              Confirm Decline
            </Button>
          </div>
        </div>
      ) : (
        <>
          {expiredWhileActionable && (
            <p className="flex items-start gap-2 rounded-md border border-yellow-200 bg-yellow-50 px-3 py-2 text-xs text-yellow-800">
              <CalendarClock className="mt-0.5 size-4 shrink-0" />
              <span>
                {expiredQuoteMessage({
                  validUntil: estimate.validUntil,
                  showValidUntil: v.validUntil,
                  formatDate: fmtDateOnly,
                })}
              </span>
            </p>
          )}
          <Button
            className={approveButtonClass}
            onClick={() => setApproveModalOpen(true)}
            disabled={submitting || expiredWhileActionable}
          >
            {approveAndPay ? 'Approve and pay' : 'Approve Estimate'}
          </Button>
          <Button
            variant="outline"
            className="w-full"
            onClick={() => setShowDeclineForm(true)}
            disabled={submitting}
          >
            Decline Estimate
          </Button>
        </>
      )}
    </div>
  );
}
